import { render, staticRenderFns } from "./SuccessItem.vue?vue&type=template&id=31687808&scoped=true"
import script from "./SuccessItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SuccessItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SuccessItem.vue?vue&type=style&index=0&id=31687808&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31687808",
  null
  
)

export default component.exports